import { render, staticRenderFns } from "./productosFacturaDeCompra.vue?vue&type=template&id=d2c54324&scoped=true"
import script from "./productosFacturaDeCompra.vue?vue&type=script&lang=js"
export * from "./productosFacturaDeCompra.vue?vue&type=script&lang=js"
import style0 from "./productosFacturaDeCompra.vue?vue&type=style&index=0&id=d2c54324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c54324",
  null
  
)

export default component.exports